export default () => ({
    restrict: 'A',
    link(scope, elem, attrs) {
        const limit = parseInt(attrs.limitTo);
        angular.element(elem).on('keypress', function (e) {
            if (this.value.length == limit) e.preventDefault();
        });
    },
});
